<template>
  <div class="ccui-app-container">
    <div class="ccui-advanced-search-wrapper ccui-clearfix">
      <el-search
        :formProp="formData"
        @search="searchItem"
        :isShowSearch="isShowSearch"
        class="ccui-highsearch no-print"
        :selectClear="true"
        width="460px"
      >
        <div class="ccui-tab-wrapper">
          <el-button type="table-top-active" size="mini"
            >询价定投统计表</el-button
          >
        </div>
        <div class="ccui-extend-btn">
          <el-button
            size="mini"
            type="primary"
            icon="icon-ccui-export"
            style="float: right;"
            @click="handlExport"
            >导出</el-button
          >
          <el-button
            size="mini"
            type="primary"
            icon="icon-ccui-print"
            style="float: right;margin-right: 10px;"
            @click="handlePrint"
            >打印</el-button
          >
        </div>
        <template slot="search">
          <el-date-picker
            v-model="formData.advancedDatePicker"
            searchLabel="定标日期"
            clearable
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          <el-tree-selector
            :props="props"
            :state="state"
            searchLabel="经办单位"
            placeholder="请选择经办单位查询"
            :loadNode="loadNode"
            :defaultKeys="defaultID"
            @onSubmitSingle="onSubmitSingle"
            v-model="formData.orgId"
          >
          </el-tree-selector>
          <el-price-range
            v-model="formData.totalMoney"
            searchLabel="定标总金额（万元）"
            clearable
          ></el-price-range>
        </template>
        <el-date-picker
          v-model="formData.advancedDatePicker"
          searchLabel="定标日期"
          clearable
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          slot="searchItem1"
        >
        </el-date-picker>
        <el-tree-selector
          :props="props"
          :state="state"
          searchLabel="经办单位"
          placeholder="请选择经办单位查询"
          :loadNode="loadNode"
          :defaultKeys="defaultID"
          @onSubmitSingle="onSubmitSingle"
          v-model="formData.orgId"
          slot="searchItem2"
        >
        </el-tree-selector>
        <el-price-range
          v-model="formData.totalMoney"
          searchLabel="定标总金额（万元）"
          clearable
          slot="searchItem3"
          formClass="ccui-pre-form"
        ></el-price-range>
      </el-search>
    </div>
    <div class="ccui-multifunctional-table-wrapper">
      <el-card-title
        :content-text="content"
        style="width: auto;margin: 0"
        class="no-screen"
        title="询价定投统计表"
      />
      <el-table
        ref="tableList"
        :header-cell-style="{ background: '#ffffff', color: '#4A4A4A' }"
        :data="tableData"
        :load="loadTreeNode"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        lazy
        style="width: 100%"
        row-key="tableIndex"
        highlight-current-row
        border
        class="ccui-multifunctional-table"
        @header-click="handlePopoverShow"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          type="index"
          label="序号"
          width="60"
        />
        <el-table-column
          :show-overflow-tooltip="true"
          prop="name"
          label="经办单位"
          min-width="300"
        />
        <el-table-column
          :show-overflow-tooltip="true"
          prop="scaleTime"
          label="定标日期"
          width="180"
        />
        <el-table-column
          :show-overflow-tooltip="true"
          prop="scaleNum"
          label="定标数量"
          width="80"
        />
        <el-table-column
          :show-overflow-tooltip="true"
          prop="projectedMoney"
          label="预计总金额（万元）"
          width="150"
        />
        <el-table-column
          :show-overflow-tooltip="true"
          prop="scaleMoney"
          label="定标总金额（万元）"
          width="150"
        />
      </el-table>
    </div>
    <div class="table-bottom-div"></div>
  </div>
</template>
<script>
require("core-js/modules/es.object.assign");
require("core-js/modules/es.object.keys");
require("regenerator-runtime/runtime");
require("core-js/modules/es.object.values");
require("core-js/modules/es.object.set-prototype-of");
require("core-js/modules/es.array.find");
require("core-js/modules/es.array-buffer.is-view");
require("core-js/modules/es.weak-map");
require("core-js/modules/es.promise");
const ExcelJS = require("exceljs");
import { saveAs } from "file-saver";
import { getInquirySummary } from "../api/inquiry-collect";
// getQryOrgTree
import {
  numberFilter,
  clearComma,
  ishasAgentId,
  findIndex,
  dateFormat
} from "@/basa/utils";

export default {
  name: "OrderStatistic",
  data() {
    return {
      // 树形结构模拟数据
      count: "1",
      searchData: [],
      orgType: "1",
      defaultID: ["1"],
      props: {
        label: "label",
        name: "name",
        children: "abbrName",
        isLeaf: "isLeaf"
      },
      state: "",
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ]
      },
      // Todo 表格数据 start
      defaultFormThead: [
        // { label: '序号', prop: 'id', width: 50, checked: true },
        { label: "定标日期", prop: "scaleTime", width: 150, checked: true },
        { label: "定标数量", prop: "scaleNum", width: 150, checked: true },
        {
          label: "预计采购金额（万元）",
          prop: "projectedMoney",
          width: 200,
          checked: true,
          align: "right"
        },
        {
          label: "定标金额（万元）",
          prop: "scaleMoney",
          width: 150,
          checked: true,
          align: "right"
        },
        {
          label: "经办单位/部门",
          prop: "",
          width: 150,
          checked: true,
          align: "right"
        },
        { label: "中标供应商", prop: "", width: 150, checked: true },
        { label: "供应商来源", prop: "", width: 150, checked: false },
        { label: "询价单编号", prop: "", width: 150, checked: false }
      ],
      formTheadOptions: [],
      defaulTable: this.tableList.inquiryCollect,
      popoverShow: false,
      currentPlaceholder: "请选择定标日期查询",
      currentView: "advanced-date-picker",
      myWidth: 0,
      btncolor: [],
      multiDataToEnd: {},
      singleDataToEnd: {},
      excelExport: [],
      excelData: [],
      tableMaxHeight: 0,
      elCardBodyHeight: 0,
      content: "制表单位/制表人/日期：中交信科/游欢欢 2019.04.01",
      tableData: [],
      tableParams: {
        parentId: "",
        extOid: "",
        scaleTimes: [],
        startScaleMoney: "",
        endScaleMoney: "",
        type: ""
      },
      filedData: {},
      isComeIn: false,
      tableIndex: 0,
      // Todo 表格数据 end

      // Todo 高级搜索数据 start
      formData: {
        advancedDatePicker: "",
        orgId: "",
        totalMoney: []
      },
      isShowSearch: true,
      value: "",
      scaleTimes: null,
      goodsName: "",
      startTime: "",
      endTime: "",
      fixed: true,
      // Todo 高级搜索数据 end
      acfun: false
    };
  },
  activated() {
    setTimeout(() => {
      this.$refs.tableList.bodyWrapper.scrollTop = this.scrollTop;
    }, 20);
  },
  created() {
    this.renderTable();
  },
  mounted() {
    const date = new Date();
    let formatDate = dateFormat("YYYY-mm-dd", date);
    this.scaleTimes = [formatDate];
    this.startTime = date.getFullYear() + "-" + "01-01";
    this.endTime = this.scaleTimes.slice(0)[0];
    this.scaleTimes.unshift(this.startTime);
    this.tableParams.scaleTimes = JSON.parse(JSON.stringify(this.scaleTimes));
    this.getData();
    this.pointEvent();
  },
  beforeDestroy() {
    this.removePrint(this);
  },
  methods: {
    // Todo 表格所需函数 start
    handlePopoverShow(column, event) {
      if (column.label === "set") {
        this.popoverShow = !this.popoverShow;
      }
    },
    renderTable() {
      const localTableData = JSON.parse(localStorage.getItem(this.defaulTable));
      if (localTableData) {
        this.formTheadOptions = localTableData;
        this.defaultFormThead = localTableData;
      } else {
        const comment = JSON.stringify(this.defaultFormThead);
        localStorage.setItem(this.defaulTable, comment);
        const localTableData = JSON.parse(
          localStorage.getItem(this.defaulTable)
        );
        this.formTheadOptions = localTableData;
      }
    },
    // 列表树添加
    loadTreeNode(tree, treeNode, resolve) {
      this.tableParams.parentId = tree.orgId;
      this.tableParams.type = tree.type;
      this.getData(resolve);
    },
    // 默认展开数据一层
    expandAll() {
      if (this.isComeIn) {
        return false;
      }
      this.isComeIn = true;
      const els = document.getElementsByClassName("el-table__expand-icon");
      try {
        els[0].click();
      } catch (e) {
        console.log(e);
      }
    },
    ExportExcel(data) {
      const index = findIndex(
        this.excelData,
        "orgId",
        this.tableParams.parentId
      );
      data.unshift(index + 1, 0);
      Array.prototype.splice.apply(this.excelData, data);
    },
    // Todo 表格所需函数 end

    // Todo 高级搜索所需函数 start
    // zh_单搜索清空
    searchItem(searchData) {
      if (searchData.advancedDatePicker) {
        this.tableParams.scaleTimes = searchData.advancedDatePicker;
      }
      if (searchData.totalMoney && searchData.totalMoney.length > 0) {
        this.tableParams.startScaleMoney = searchData.totalMoney[0];
        this.tableParams.endScaleMoney = searchData.totalMoney[0];
      }
      this.getData();
    },
    // 获取列表数据，调出查询方法
    getData(resolve) {
      // this.tableData = []
      this.tableParams.isShowPageLoading = true;
      getInquirySummary(this.tableParams)
        .then(res => {
          if (res.data.code === "0") {
            this.filedData = res.data;
            if (!resolve) {
              this.tableData = this.filedData.data;
              this.excelData = this.filedData.data.slice(0);
            } else {
              this.ExportExcel(res.data.data.slice(0));
            }
            res.data.data.forEach(item => {
              item.tableIndex = this.tableIndex + "";
              this.tableIndex++;
              item.scaleMoney = numberFilter(item.scaleMoney).newNum;
              item.scaleNum = numberFilter(item.scaleNum, true).newNum;
              item.projectedMoney = numberFilter(item.projectedMoney).newNum;
              if (item.type == "1") {
                item.hasChildren = true;
              } else {
                item.hasChildren = false;
              }
              item.specialArea = "询价专区";
            });
          }
          resolve ? resolve(res.data.data) : "";
          setTimeout(() => {
            this.expandAll();
          }, 200);
        })
        .catch(err => {
          console.log(err);
          resolve ? resolve([]) : "";
        });
    },
    // 调用浏览器打印
    handlePrint() {
      let thead = document.createElement("thead");
      thead.innerHTML = `<thead>
      <tr style="border:1px solid #EDF2FC;height: 37px">
        <th style="border-right:none;padding-left:10px">序号</th>
        <th style="border-right:none;padding-left:5px">经办单位</th>
        <th style="border-right:none;padding-left:5px">定标日期</th>
        <th style="border-right:none;padding-left:5px">定标数量</th>
        <th style="border-right:none;padding-left:5px">预计总金额(万元)</th>
        <th style="border-right:none;padding-left:5px">定标总金额(万元)</th>
      </tr>
      </thead>`;
      let acfun = document.getElementsByClassName("el-table__body")[0];
      acfun.appendChild(thead);
      this.acfun = true;
      this.$nextTick(() => {
        window.print();
      });
    },
    // 导出文件
    handlExport() {
      this.exportDefault();
    },
    async exportDefault() {
      this.excelData = JSON.parse(JSON.stringify(this.excelData));
      const wb = new ExcelJS.Workbook();
      const ws1 = wb.addWorksheet("询价定标统计");
      ws1.views = [{ state: "frozen", ySplit: 3 }];
      ws1.addRow(["询价定标统计表"]);
      ws1.addRow([this.content]);
      ws1.addRow([
        "序号",
        "经办单位",
        "定标日期",
        "定标数量",
        "预计总金额（万元）",
        "定标总金额（万元）"
      ]);
      ws1.mergeCells("A1:F1");
      ws1.mergeCells("A2:F2");

      ws1.columns = [
        { key: "index", width: 5 },
        { key: "name", width: 35 },
        { key: "scaleTime", width: 20 },
        { key: "scaleNum", width: 20 },
        { key: "projectedMoney", width: 30 },
        { key: "scaleMoney", width: 20 }
      ];
      this.excelData.forEach((item, index) => {
        item.projectedMoney = clearComma(item.projectedMoney);
        item.scaleMoney = clearComma(item.scaleMoney);
        item.scaleNum = clearComma(item.scaleNum);
        ws1.addRow([
          index + 1,
          item.name,
          item.scaleTime,
          item.scaleNum,
          item.projectedMoney,
          item.scaleMoney
        ]);
      });
      ws1.getRow(3).font = { bold: true, color: { argb: "000000" } };
      ws1.getRow(3).fill = { color: { argb: "000000" } };
      ws1.getRow(1).font = { bold: true, color: { argb: "000000" } };
      ws1.getRow(1).fill = { color: { argb: "000000" } };
      ws1.getColumn(5).alignment = { vertical: "middle", horizontal: "right" };
      ws1.getColumn(6).alignment = { vertical: "middle", horizontal: "right" };
      ws1.getColumn(5).alignment = { vertical: "middle", horizontal: "right" };
      ws1.getRow(1).alignment = { vertical: "middle", horizontal: "center" };
      ws1.getRow(2).alignment = { vertical: "middle", horizontal: "left" };
      ws1.getColumn(4).numFmt = "#,##";
      ws1.getColumn(5).numFmt = "#,##0.00";
      ws1.getColumn(6).numFmt = "#,##0.00";

      const buf = await wb.xlsx.writeBuffer();
      saveAs(new Blob([buf]), "询价定标统计表.xlsx");
    },
    pointEvent() {
      window.addEventListener("beforeprint", event => {
        let acfun = document.getElementsByClassName(
          "el-table__header-wrapper"
        )[0];
        acfun.style.display = "none";
      });
      window.addEventListener("afterprint", event => {
        this.acfun = false;
        let acfun = document.getElementsByClassName(
          "el-table__header-wrapper"
        )[0];
        acfun.style.display = "table";
        let acfuns = document.getElementsByClassName("el-table__body")[0];
        acfuns.removeChild(acfuns.childNodes[2]);
      });
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        return resolve([{ label: "运营中心1", id: "1" }]);
      }
      if (node.level > 3) return resolve([]);

      let hasChild;
      if (node.data.id === "1") {
        hasChild = true;
      } else {
        hasChild = Math.random() > 0.4;
      }
      setTimeout(() => {
        let data;
        if (hasChild) {
          data = [
            {
              label: "交建云商" + this.count++,
              name: "交建云商运营中心交建云商运营中心" + this.count++,
              id: this.count++
            },
            {
              label: "交建云商999" + this.count++,
              orgType: "1",
              name: "交建云商交建云商运营中心交建云商运营中心" + this.count++,
              id: this.count++
            },
            {
              label: "交建云商" + this.count++,
              name: "交建云商交建云商运营中心交建云商运营中心" + this.count++,
              id: this.count++
            },
            {
              label: "交建云商" + this.count++,
              name: "交建云商交建云商运营中心交建云商运营中心" + this.count++,
              id: this.count++
            },
            {
              label: "交建云" + this.count++,
              name: "交建云商交建云商运营中心交建云商运营中心" + this.count++,
              id: this.count++
            },
            {
              label: "交建云商" + this.count++,
              name: "交建云商交建云商运营中心交建云商运营中心" + this.count++,
              id: this.count++
            }
          ];
        } else {
          data = [];
        }
        resolve(data);
      }, 500);
    },
    onSubmitSingle(obj) {
      this.searchData = obj;
    }
  },
  beforeRouteLeave(to, from, next) {
    for (var key in this.$vnode.parent.componentInstance.cache) {
      delete this.$vnode.parent.componentInstance.cache[
        ishasAgentId(to.path, key)
      ];
    }
    next();
  }
};
</script>

<style lang="scss" scoped>
@media print {
  .el-table {
    width: initial !important;
    border: 1px solid #f1f1f1;
  }
  @page {
    size: A4 landscape;
    margin: 0;
  }
}
</style>
